type OverlayKind = 'modal' | 'other';

type OverlayEntry = {
  token: symbol;
  kind: OverlayKind;
};

let overlayStack: OverlayEntry[] = [];

let savedBodyOverflow: string | null = null;

const listeners = new Set<() => void>();

function notifyOverlayListeners() {
  for (const listener of listeners) {
    listener();
  }
}

export function acquireOverlay(kind: OverlayKind = 'other'): symbol {
  const token = Symbol('overlay');
  overlayStack = [...overlayStack, { token, kind }];

  if (overlayStack.length === 1) {
    savedBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  notifyOverlayListeners();
  return token;
}

export function releaseOverlay(token: symbol) {
  const next = overlayStack.filter((entry) => entry.token !== token);
  overlayStack = next;

  if (overlayStack.length === 0) {
    document.body.style.overflow = savedBodyOverflow ?? '';
    savedBodyOverflow = null;
  }

  notifyOverlayListeners();
}

export function isOverlayTopmost(token: symbol) {
  return overlayStack.length > 0 && overlayStack[overlayStack.length - 1]?.token === token;
}

export function getOverlayCount(): number {
  return overlayStack.length;
}

/** Modals only. Popovers also join the stack, but they must not hide the search layer. */
export function getModalOverlayCount(): number {
  return overlayStack.reduce((count, entry) => count + (entry.kind === 'modal' ? 1 : 0), 0);
}

/** Subscribe to overlay open/close changes (e.g. hide FAB while a modal is open). */
export function subscribeOverlayStack(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
